import { 
    GET_CONFIG_FORM13,
    GET_COMBO_TIPO_GESTION,
    GET_COMBO_CAMBIAR_AMBITO_GESTION,
    GET_COMBO_HITOS,
    POST_CAMBIAR_GESTION
} from '../types';

export default function recepcionaCasoReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM13:
            return { ...state, cfg_form13:action.payload }
        case GET_COMBO_TIPO_GESTION:
            return { ...state, comboTipoGestion:action.payload }
        case GET_COMBO_CAMBIAR_AMBITO_GESTION:
            return { ...state, comboCAmbitoGestion:action.payload }
        case GET_COMBO_HITOS:
            return { ...state, comboHitos:action.payload }
        case POST_CAMBIAR_GESTION:
            return { ...state, respuestaCambiandoGestion:action.payload }
       
       
        default:
            return state
    }
}